import { useEffect } from "react";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useUserConsent } from "../../../../utils/consentManagement";
const KEY = "consent";
export const useInitConsent = () => {
    const isUserConsent = useUserConsent();
    const { dispatch } = useOverlayOrchestrator();
    useEffect(() => {
        if (isUserConsent) {
            dispatch({ type: "COMPLETE", payload: KEY });
        }
    }, [dispatch, isUserConsent]);
};
